/**
 * Ensures the CamSur logo is used as the browser tab icon.
 * Needed because craco ignores `public/**` for webpack watch, so edits to
 * `public/index.html` are not picked up until the dev server is restarted.
 */
const FAVICON_HREF = `${process.env.PUBLIC_URL || ''}/favicon.png?v=camsur-logo`;

export function setupFavicon() {
  if (typeof document === 'undefined') return;

  const head = document.head || document.getElementsByTagName('head')[0];
  if (!head) return;

  const selectors = [
    'link[rel="icon"]',
    'link[rel="shortcut icon"]',
    'link[rel="apple-touch-icon"]',
  ];

  selectors.forEach((sel) => {
    head.querySelectorAll(sel).forEach((el) => el.remove());
  });

  const icon = document.createElement('link');
  icon.rel = 'icon';
  icon.type = 'image/png';
  icon.href = FAVICON_HREF;
  head.appendChild(icon);

  const shortcut = document.createElement('link');
  shortcut.rel = 'shortcut icon';
  shortcut.type = 'image/png';
  shortcut.href = FAVICON_HREF;
  head.appendChild(shortcut);

  const apple = document.createElement('link');
  apple.rel = 'apple-touch-icon';
  apple.href = `${process.env.PUBLIC_URL || ''}/apple-touch-icon.png?v=camsur-logo`;
  head.appendChild(apple);
}
